import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var Intl = /*#__PURE__*/function () {
  function Intl(data) {
    _classCallCheck(this, Intl);
    this._data = data;
    this.active = data.zh_CN;
    this.locale = "zh_CN";
  }
  _createClass(Intl, [{
    key: "changeLocale",
    value: function changeLocale(locale) {
      if (this._data[locale]) {
        this.locale = locale;
        this.active = this._data[locale] || this.data.zh_CN;
      }
    }
  }, {
    key: "loadData",
    value: function loadData(data) {
      this._data = data;
      if (this.locale) {
        this.active = this._data[this.locale];
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var realValue = this.active[key];
      return {
        d: function d(defaultValue) {
          return realValue || defaultValue;
        }
      };
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      return this.locale;
    }
  }]);
  return Intl;
}();